// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qd3c","col":"styles_col__1tv8Z"};